import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadError, update } from '../../Actions/Cart.action';
import { debounce } from 'lodash-es';
import { catchError } from '../../Actions/Error.action';
import { translate } from '../../Services/translation';

const CheckoutCartItem = ({ article }) => {
  const dispatch = useDispatch();
  const [cartQuantity, setCartQuantity] = useState(article.quantity);
  const [errorMessage, setErrorMessage] = useState('');
  const cart = useSelector((state) => state.cart);

  const mapCartToAbort = useRef({});

  const updateCart = useRef(
    debounce((rowSystemId, quantity) => {
      mapCartToAbort.current[rowSystemId] = new AbortController();
      dispatch(
        update(rowSystemId, quantity, mapCartToAbort.current[rowSystemId])
      ).catch((ex) => {
        dispatch(catchError(ex, (error) => loadError(error)));
      });
    }, 500)
  ).current;

  useEffect(() => {
    setCartQuantity(article.quantity);
  }, [article.quantity]);

  function updateCartItem(newTotal) {
    setErrorMessage('');

    updateCart(article.rowSystemId, newTotal);

    // Clean up function to cancel any pending requests
    return () => {
      Object.values(mapCartToAbort.current).forEach((controller) => {
        controller.abort();
      });
    };
  }

  function isAvailableInStock(newTotal) {
    return newTotal <= article.maxQuantity;
    let rows = cart.orderRows.filter((x) => x.rowSys === article.rowSys);

    if (rows === 0) {
      return newTotal <= article.maxQuantity;
    }

    let amount = rows.reduce((sum, x) => sum + x.quantity, 0);

    return amount + newTotal <= article.maxQuantity;
  }

  function decrement() {
    let newTotal = cartQuantity - article.minQuantity;

    if (newTotal > 0) {
      setCartQuantity(newTotal);

      return updateCartItem(newTotal);
    }

    setErrorMessage(translate('cart.item.quantity.minquantity'));
  }

  function increment() {
    let newTotal = cartQuantity + article.minQuantity;

    if (article.isOrderItem) {
      setCartQuantity(newTotal);

      return updateCartItem(newTotal);
    }

    if (isAvailableInStock(newTotal)) {
      setCartQuantity(newTotal);

      return updateCartItem(newTotal);
    }

    setErrorMessage(translate('cart.item.quantity.notenoughinstock'));
  }

  return (
    <>
      <div>
        <div className="checkout__article-image-container">
          <img className="checkout__article-image" src={article.image} alt="" />
        </div>
      </div>
      <div style={{ width: '100%' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <a href={article.url} className="checkout__article-title">
            {article.name}
          </a>
          <button
            type="button"
            className="checkout__article-button"
            onClick={() => dispatch(update(article.rowSystemId, 0))}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M2.5 5H4.16667H17.5"
                stroke="#373D41"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.8334 5.00033V16.667C15.8334 17.109 15.6578 17.5329 15.3453 17.8455C15.0327 18.1581 14.6088 18.3337 14.1667 18.3337H5.83341C5.39139 18.3337 4.96746 18.1581 4.6549 17.8455C4.34234 17.5329 4.16675 17.109 4.16675 16.667V5.00033M6.66675 5.00033V3.33366C6.66675 2.89163 6.84234 2.46771 7.1549 2.15515C7.46746 1.84259 7.89139 1.66699 8.33341 1.66699H11.6667C12.1088 1.66699 12.5327 1.84259 12.8453 2.15515C13.1578 2.46771 13.3334 2.89163 13.3334 3.33366V5.00033"
                stroke="#373D41"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.33325 9.16699V14.167"
                stroke="#373D41"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.6667 9.16699V14.167"
                stroke="#373D41"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div>
          <p className="checkout__article-price">
            {article.campaignPrice ?? article.price}
          </p>

          {article.information.map((x, index) => {
            return (
              <p className="checkout__article-information" key={index}>
                {x}
              </p>
            );
          })}
        </div>
        <div className="checkout__article-row">
          <div></div>
          <div className="cart__content__item__product-info__item__counter">
            <button
              type="button"
              id="itemcounter-remove"
              onClick={() => decrement()}
            >
              -
            </button>
            <div id="itemcounter-current">{cartQuantity}</div>
            <button
              type="button"
              id="itemcounter-add"
              onClick={() => increment()}
            >
              +
            </button>
          </div>
        </div>

        {errorMessage && (
          <p className="checkout__article-error-message">{errorMessage}</p>
        )}

        {article.totalCampaignPrice ? (
          <>
            <p className="checkout__article-price-total checkout__article-price-total--old">
              {article.totalPrice}
            </p>
            <p className="checkout__article-price-total checkout__article-price-total--discounted">
              {article.totalCampaignPrice}
            </p>
          </>
        ) : (
          <p className="checkout__article-price-total">{article.totalPrice}</p>
        )}
      </div>
    </>
  );
};

export default CheckoutCartItem;
